module.exports = __webpack_public_path__ + "img/horse-head.33f3ee23.svg";